import React from 'react';
type CtaButtonProps = {
  label?: string;
  className?: string;
  href?: string;
};
export function CtaButton({
  label = 'I WANT CHEERLEADING READY NOW',
  className = '',
  href = '#pricing'
}: CtaButtonProps) {
  const isExternal = href.startsWith('http');
  return <a href={href} target={isExternal ? '_blank' : undefined} rel={isExternal ? 'noopener noreferrer' : undefined} className={`flex w-full items-center justify-center rounded-2xl bg-cheer px-6 py-5 text-center font-display text-base font-extrabold uppercase tracking-tight text-white shadow-cheer transition-[box-shadow,background-color,transform] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#d81b60] hover:shadow-[0_22px_50px_-14px_rgba(233,30,99,0.75)] focus:outline-none focus-visible:ring-4 focus-visible:ring-cheer/40 sm:text-lg ${className}`} data-id="element-68" data-mp="cksm49veywcm">
      {label}
    </a>;
}